import React from 'react';
import Layout from "./Layout";

function Cell(props) {
  const cellSize = Layout.cellSize

  var classname="xwordjs-cell";
  if (props.isHidden) {
    classname += " xwordjs-cell-hidden";
  } else if (props.isBlack) {
    classname += " xwordjs-cell-black";
  }
  if (props.isTop) {
    classname += " xwordjs-cell-top";
  }
  if (props.isLeft) {
    classname += " xwordjs-cell-left";
  }
  if (props.isFocus) {
    classname += " xwordjs-cell-focus";
    if (props.isIncorrect)
      classname += "-incorrect";
  } else if (props.isActive) {
    classname += " xwordjs-cell-active";
    if (props.isIncorrect)
      classname += "-incorrect";
  }

  if (props.isIncorrect && !props.isHidden)
    classname += " xwordjs-cell-incorrect";

  var circleclass = "";
  if (props.isCircled) {
    circleclass = "xwordjs-cell-circled";
  }

  if (props.isGreyed) {
    classname += " xwordjs-cell-greyed";
  }

  const circlePadding = ((cellSize / 25) * 5 - 5) / 2
  const circleRadius = cellSize - circlePadding - circlePadding - 1

  let fontsize = Math.round(14 * (cellSize / 25));
  if (props.value.length > 2) {
    fontsize = Math.round((30 / props.value.length) * (cellSize / 25));
  }
  const fontSizeNumber = Math.min(0.6 * (cellSize / 25), 1)
  return <div className={classname} id={props.id} style={{ width: cellSize, height: cellSize, minWidth: cellSize, minHeight: cellSize }} onClick={() => props.onClick(props.id)} onTouchEnd={(e) => {props.onClick(props.id); e.preventDefault();}}>
            <div className="xwordjs-cell-number" style={{ "fontSize": fontSizeNumber + "em", "lineHeight": fontSizeNumber + "em" }}>{props.number}</div>
            <div className={circleclass} style={{ marginLeft: circlePadding, marginTop: circlePadding, width: circleRadius, height: circleRadius, minWidth: circleRadius, minHeight: circleRadius }}>
              <div className="xwordjs-cell-text" style={{"fontSize": fontsize + "px", "lineHeight": circleRadius + "px" }}>{props.value}</div>
            </div>
          </div>;
}

export default Cell;
